import React from 'react';
import Head from 'next/head';
import { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { useFAQ } from '../components/structuredData/useFAQ';
import { useWebPageGraph } from '../components/structuredData/useWepPageGraph';
import { CashbackCalculator } from '../features/cashbackCalculator/CashbackCalculator';
import { Layout } from '../components/layout/redesign/Layout';
import { LayoutSpacer } from '../components/BankInfo/LayoutSpacer';

export default function FondsCommissionCalculatorPage() {
  const { t } = useTranslation();
  const faqLdJson = useFAQ();
  const webPageLdJson = useWebPageGraph(
    t('cashbackCalculator.title'),
    t('cashbackCalculator.description')
  );

  return (
    <Layout>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqLdJson),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(webPageLdJson),
          }}
        />
        <title>{t('cashbackCalculator.title')}</title>
        <meta name="language" content="deutsch, de" />
        <meta name="robots" content="noodp,index,follow" />

        <meta name="keywords" content={t('cashbackCalculator.keywords')} />
        <meta name="description" content={t('cashbackCalculator.description')} />
        <meta name="page-topic" content={t('cashbackCalculator.pageTopics')} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rentablo.de" />
        <meta property="og:title" content={t('cashbackCalculator.title')} />
        <meta property="og:site_name" content={t('cashbackCalculator.title')} />
        <meta
          property="og:image"
          content="https://rentablo.de/images/sharing/rentablo-cashback.jpg"
        />
        <meta
          property="og:image"
          content="https://rentablo.de/images/sharing/rentablo-cashback-explanation.jpg"
        />
        <meta property="og:image" content="https://rentablo.de/images/rentablo-logo-white.svg" />
        <meta property="og:image" content="https://rentablo.de/images/rentablo-phone.jpg" />
        <meta property="og:image" content="https://rentablo.de/images/rentablo-mobile.jpg" />
        <meta property="og:description" content={t('cashbackCalculator.description')} />
      </Head>
      <LayoutSpacer spacing={16} />
      <CashbackCalculator />
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
